// source: common.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_duration_pb = require('google-protobuf/google/protobuf/duration_pb.js');
goog.object.extend(proto, google_protobuf_duration_pb);
goog.exportSymbol('proto.jungletv.AnnouncementsUpdatedNotification', null, global);
goog.exportSymbol('proto.jungletv.ChatMentionNotification', null, global);
goog.exportSymbol('proto.jungletv.ConfigurationChange', null, global);
goog.exportSymbol('proto.jungletv.ConfigurationChange.ConfigurationChangeCase', null, global);
goog.exportSymbol('proto.jungletv.ConfigurationChangeAddNavigationDestination', null, global);
goog.exportSymbol('proto.jungletv.ConfigurationChangeSidebarTabOpen', null, global);
goog.exportSymbol('proto.jungletv.NavigationDestinationHighlightedNotification', null, global);
goog.exportSymbol('proto.jungletv.Notification', null, global);
goog.exportSymbol('proto.jungletv.Notification.NotificationDataCase', null, global);
goog.exportSymbol('proto.jungletv.PaginationParameters', null, global);
goog.exportSymbol('proto.jungletv.RewardBalanceUpdateReason', null, global);
goog.exportSymbol('proto.jungletv.RewardBalanceUpdatedNotification', null, global);
goog.exportSymbol('proto.jungletv.SidebarTabHighlightedNotification', null, global);
goog.exportSymbol('proto.jungletv.ToastNotification', null, global);
goog.exportSymbol('proto.jungletv.User', null, global);
goog.exportSymbol('proto.jungletv.UserRole', null, global);
goog.exportSymbol('proto.jungletv.UserStatus', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jungletv.User = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.jungletv.User.repeatedFields_, null);
};
goog.inherits(proto.jungletv.User, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jungletv.User.displayName = 'proto.jungletv.User';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jungletv.PaginationParameters = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jungletv.PaginationParameters, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jungletv.PaginationParameters.displayName = 'proto.jungletv.PaginationParameters';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jungletv.Notification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.jungletv.Notification.oneofGroups_);
};
goog.inherits(proto.jungletv.Notification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jungletv.Notification.displayName = 'proto.jungletv.Notification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jungletv.ChatMentionNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jungletv.ChatMentionNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jungletv.ChatMentionNotification.displayName = 'proto.jungletv.ChatMentionNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jungletv.AnnouncementsUpdatedNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jungletv.AnnouncementsUpdatedNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jungletv.AnnouncementsUpdatedNotification.displayName = 'proto.jungletv.AnnouncementsUpdatedNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jungletv.RewardBalanceUpdatedNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jungletv.RewardBalanceUpdatedNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jungletv.RewardBalanceUpdatedNotification.displayName = 'proto.jungletv.RewardBalanceUpdatedNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jungletv.SidebarTabHighlightedNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jungletv.SidebarTabHighlightedNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jungletv.SidebarTabHighlightedNotification.displayName = 'proto.jungletv.SidebarTabHighlightedNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jungletv.NavigationDestinationHighlightedNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jungletv.NavigationDestinationHighlightedNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jungletv.NavigationDestinationHighlightedNotification.displayName = 'proto.jungletv.NavigationDestinationHighlightedNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jungletv.ToastNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jungletv.ToastNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jungletv.ToastNotification.displayName = 'proto.jungletv.ToastNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jungletv.ConfigurationChange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.jungletv.ConfigurationChange.oneofGroups_);
};
goog.inherits(proto.jungletv.ConfigurationChange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jungletv.ConfigurationChange.displayName = 'proto.jungletv.ConfigurationChange';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jungletv.ConfigurationChangeSidebarTabOpen = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jungletv.ConfigurationChangeSidebarTabOpen, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jungletv.ConfigurationChangeSidebarTabOpen.displayName = 'proto.jungletv.ConfigurationChangeSidebarTabOpen';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jungletv.ConfigurationChangeAddNavigationDestination = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jungletv.ConfigurationChangeAddNavigationDestination, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jungletv.ConfigurationChangeAddNavigationDestination.displayName = 'proto.jungletv.ConfigurationChangeAddNavigationDestination';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.jungletv.User.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jungletv.User.prototype.toObject = function(opt_includeInstance) {
  return proto.jungletv.User.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jungletv.User} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jungletv.User.toObject = function(includeInstance, msg) {
  var f, obj = {
    address: jspb.Message.getFieldWithDefault(msg, 1, ""),
    rolesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    nickname: jspb.Message.getFieldWithDefault(msg, 3, ""),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jungletv.User}
 */
proto.jungletv.User.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jungletv.User;
  return proto.jungletv.User.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jungletv.User} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jungletv.User}
 */
proto.jungletv.User.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 2:
      var values = /** @type {!Array<!proto.jungletv.UserRole>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addRoles(values[i]);
      }
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    case 4:
      var value = /** @type {!proto.jungletv.UserStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jungletv.User.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jungletv.User.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jungletv.User} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jungletv.User.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRolesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional string address = 1;
 * @return {string}
 */
proto.jungletv.User.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.User} returns this
 */
proto.jungletv.User.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated UserRole roles = 2;
 * @return {!Array<!proto.jungletv.UserRole>}
 */
proto.jungletv.User.prototype.getRolesList = function() {
  return /** @type {!Array<!proto.jungletv.UserRole>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.jungletv.UserRole>} value
 * @return {!proto.jungletv.User} returns this
 */
proto.jungletv.User.prototype.setRolesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.jungletv.UserRole} value
 * @param {number=} opt_index
 * @return {!proto.jungletv.User} returns this
 */
proto.jungletv.User.prototype.addRoles = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.jungletv.User} returns this
 */
proto.jungletv.User.prototype.clearRolesList = function() {
  return this.setRolesList([]);
};


/**
 * optional string nickname = 3;
 * @return {string}
 */
proto.jungletv.User.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.User} returns this
 */
proto.jungletv.User.prototype.setNickname = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.jungletv.User} returns this
 */
proto.jungletv.User.prototype.clearNickname = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jungletv.User.prototype.hasNickname = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional UserStatus status = 4;
 * @return {!proto.jungletv.UserStatus}
 */
proto.jungletv.User.prototype.getStatus = function() {
  return /** @type {!proto.jungletv.UserStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.jungletv.UserStatus} value
 * @return {!proto.jungletv.User} returns this
 */
proto.jungletv.User.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jungletv.PaginationParameters.prototype.toObject = function(opt_includeInstance) {
  return proto.jungletv.PaginationParameters.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jungletv.PaginationParameters} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jungletv.PaginationParameters.toObject = function(includeInstance, msg) {
  var f, obj = {
    offset: jspb.Message.getFieldWithDefault(msg, 1, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jungletv.PaginationParameters}
 */
proto.jungletv.PaginationParameters.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jungletv.PaginationParameters;
  return proto.jungletv.PaginationParameters.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jungletv.PaginationParameters} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jungletv.PaginationParameters}
 */
proto.jungletv.PaginationParameters.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setOffset(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jungletv.PaginationParameters.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jungletv.PaginationParameters.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jungletv.PaginationParameters} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jungletv.PaginationParameters.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOffset();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * optional uint64 offset = 1;
 * @return {number}
 */
proto.jungletv.PaginationParameters.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.jungletv.PaginationParameters} returns this
 */
proto.jungletv.PaginationParameters.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 limit = 2;
 * @return {number}
 */
proto.jungletv.PaginationParameters.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.jungletv.PaginationParameters} returns this
 */
proto.jungletv.PaginationParameters.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.jungletv.Notification.oneofGroups_ = [[4,5,6,7,8,9]];

/**
 * @enum {number}
 */
proto.jungletv.Notification.NotificationDataCase = {
  NOTIFICATION_DATA_NOT_SET: 0,
  CHAT_MENTION: 4,
  ANNOUNCEMENTS_UPDATED: 5,
  REWARD_BALANCE_UPDATED: 6,
  SIDEBAR_TAB_HIGHLIGHTED: 7,
  NAVIGATION_DESTINATION_HIGHLIGHTED: 8,
  TOAST: 9
};

/**
 * @return {proto.jungletv.Notification.NotificationDataCase}
 */
proto.jungletv.Notification.prototype.getNotificationDataCase = function() {
  return /** @type {proto.jungletv.Notification.NotificationDataCase} */(jspb.Message.computeOneofCase(this, proto.jungletv.Notification.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jungletv.Notification.prototype.toObject = function(opt_includeInstance) {
  return proto.jungletv.Notification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jungletv.Notification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jungletv.Notification.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    key: jspb.Message.getFieldWithDefault(msg, 2, ""),
    expiration: (f = msg.getExpiration()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    chatMention: (f = msg.getChatMention()) && proto.jungletv.ChatMentionNotification.toObject(includeInstance, f),
    announcementsUpdated: (f = msg.getAnnouncementsUpdated()) && proto.jungletv.AnnouncementsUpdatedNotification.toObject(includeInstance, f),
    rewardBalanceUpdated: (f = msg.getRewardBalanceUpdated()) && proto.jungletv.RewardBalanceUpdatedNotification.toObject(includeInstance, f),
    sidebarTabHighlighted: (f = msg.getSidebarTabHighlighted()) && proto.jungletv.SidebarTabHighlightedNotification.toObject(includeInstance, f),
    navigationDestinationHighlighted: (f = msg.getNavigationDestinationHighlighted()) && proto.jungletv.NavigationDestinationHighlightedNotification.toObject(includeInstance, f),
    toast: (f = msg.getToast()) && proto.jungletv.ToastNotification.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jungletv.Notification}
 */
proto.jungletv.Notification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jungletv.Notification;
  return proto.jungletv.Notification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jungletv.Notification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jungletv.Notification}
 */
proto.jungletv.Notification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExpiration(value);
      break;
    case 4:
      var value = new proto.jungletv.ChatMentionNotification;
      reader.readMessage(value,proto.jungletv.ChatMentionNotification.deserializeBinaryFromReader);
      msg.setChatMention(value);
      break;
    case 5:
      var value = new proto.jungletv.AnnouncementsUpdatedNotification;
      reader.readMessage(value,proto.jungletv.AnnouncementsUpdatedNotification.deserializeBinaryFromReader);
      msg.setAnnouncementsUpdated(value);
      break;
    case 6:
      var value = new proto.jungletv.RewardBalanceUpdatedNotification;
      reader.readMessage(value,proto.jungletv.RewardBalanceUpdatedNotification.deserializeBinaryFromReader);
      msg.setRewardBalanceUpdated(value);
      break;
    case 7:
      var value = new proto.jungletv.SidebarTabHighlightedNotification;
      reader.readMessage(value,proto.jungletv.SidebarTabHighlightedNotification.deserializeBinaryFromReader);
      msg.setSidebarTabHighlighted(value);
      break;
    case 8:
      var value = new proto.jungletv.NavigationDestinationHighlightedNotification;
      reader.readMessage(value,proto.jungletv.NavigationDestinationHighlightedNotification.deserializeBinaryFromReader);
      msg.setNavigationDestinationHighlighted(value);
      break;
    case 9:
      var value = new proto.jungletv.ToastNotification;
      reader.readMessage(value,proto.jungletv.ToastNotification.deserializeBinaryFromReader);
      msg.setToast(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jungletv.Notification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jungletv.Notification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jungletv.Notification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jungletv.Notification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getExpiration();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getChatMention();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.jungletv.ChatMentionNotification.serializeBinaryToWriter
    );
  }
  f = message.getAnnouncementsUpdated();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.jungletv.AnnouncementsUpdatedNotification.serializeBinaryToWriter
    );
  }
  f = message.getRewardBalanceUpdated();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.jungletv.RewardBalanceUpdatedNotification.serializeBinaryToWriter
    );
  }
  f = message.getSidebarTabHighlighted();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.jungletv.SidebarTabHighlightedNotification.serializeBinaryToWriter
    );
  }
  f = message.getNavigationDestinationHighlighted();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.jungletv.NavigationDestinationHighlightedNotification.serializeBinaryToWriter
    );
  }
  f = message.getToast();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.jungletv.ToastNotification.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {string}
 */
proto.jungletv.Notification.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.Notification} returns this
 */
proto.jungletv.Notification.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional string key = 2;
 * @return {string}
 */
proto.jungletv.Notification.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.Notification} returns this
 */
proto.jungletv.Notification.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp expiration = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.jungletv.Notification.prototype.getExpiration = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.jungletv.Notification} returns this
*/
proto.jungletv.Notification.prototype.setExpiration = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jungletv.Notification} returns this
 */
proto.jungletv.Notification.prototype.clearExpiration = function() {
  return this.setExpiration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jungletv.Notification.prototype.hasExpiration = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ChatMentionNotification chat_mention = 4;
 * @return {?proto.jungletv.ChatMentionNotification}
 */
proto.jungletv.Notification.prototype.getChatMention = function() {
  return /** @type{?proto.jungletv.ChatMentionNotification} */ (
    jspb.Message.getWrapperField(this, proto.jungletv.ChatMentionNotification, 4));
};


/**
 * @param {?proto.jungletv.ChatMentionNotification|undefined} value
 * @return {!proto.jungletv.Notification} returns this
*/
proto.jungletv.Notification.prototype.setChatMention = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.jungletv.Notification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jungletv.Notification} returns this
 */
proto.jungletv.Notification.prototype.clearChatMention = function() {
  return this.setChatMention(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jungletv.Notification.prototype.hasChatMention = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional AnnouncementsUpdatedNotification announcements_updated = 5;
 * @return {?proto.jungletv.AnnouncementsUpdatedNotification}
 */
proto.jungletv.Notification.prototype.getAnnouncementsUpdated = function() {
  return /** @type{?proto.jungletv.AnnouncementsUpdatedNotification} */ (
    jspb.Message.getWrapperField(this, proto.jungletv.AnnouncementsUpdatedNotification, 5));
};


/**
 * @param {?proto.jungletv.AnnouncementsUpdatedNotification|undefined} value
 * @return {!proto.jungletv.Notification} returns this
*/
proto.jungletv.Notification.prototype.setAnnouncementsUpdated = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.jungletv.Notification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jungletv.Notification} returns this
 */
proto.jungletv.Notification.prototype.clearAnnouncementsUpdated = function() {
  return this.setAnnouncementsUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jungletv.Notification.prototype.hasAnnouncementsUpdated = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional RewardBalanceUpdatedNotification reward_balance_updated = 6;
 * @return {?proto.jungletv.RewardBalanceUpdatedNotification}
 */
proto.jungletv.Notification.prototype.getRewardBalanceUpdated = function() {
  return /** @type{?proto.jungletv.RewardBalanceUpdatedNotification} */ (
    jspb.Message.getWrapperField(this, proto.jungletv.RewardBalanceUpdatedNotification, 6));
};


/**
 * @param {?proto.jungletv.RewardBalanceUpdatedNotification|undefined} value
 * @return {!proto.jungletv.Notification} returns this
*/
proto.jungletv.Notification.prototype.setRewardBalanceUpdated = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.jungletv.Notification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jungletv.Notification} returns this
 */
proto.jungletv.Notification.prototype.clearRewardBalanceUpdated = function() {
  return this.setRewardBalanceUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jungletv.Notification.prototype.hasRewardBalanceUpdated = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional SidebarTabHighlightedNotification sidebar_tab_highlighted = 7;
 * @return {?proto.jungletv.SidebarTabHighlightedNotification}
 */
proto.jungletv.Notification.prototype.getSidebarTabHighlighted = function() {
  return /** @type{?proto.jungletv.SidebarTabHighlightedNotification} */ (
    jspb.Message.getWrapperField(this, proto.jungletv.SidebarTabHighlightedNotification, 7));
};


/**
 * @param {?proto.jungletv.SidebarTabHighlightedNotification|undefined} value
 * @return {!proto.jungletv.Notification} returns this
*/
proto.jungletv.Notification.prototype.setSidebarTabHighlighted = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.jungletv.Notification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jungletv.Notification} returns this
 */
proto.jungletv.Notification.prototype.clearSidebarTabHighlighted = function() {
  return this.setSidebarTabHighlighted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jungletv.Notification.prototype.hasSidebarTabHighlighted = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional NavigationDestinationHighlightedNotification navigation_destination_highlighted = 8;
 * @return {?proto.jungletv.NavigationDestinationHighlightedNotification}
 */
proto.jungletv.Notification.prototype.getNavigationDestinationHighlighted = function() {
  return /** @type{?proto.jungletv.NavigationDestinationHighlightedNotification} */ (
    jspb.Message.getWrapperField(this, proto.jungletv.NavigationDestinationHighlightedNotification, 8));
};


/**
 * @param {?proto.jungletv.NavigationDestinationHighlightedNotification|undefined} value
 * @return {!proto.jungletv.Notification} returns this
*/
proto.jungletv.Notification.prototype.setNavigationDestinationHighlighted = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.jungletv.Notification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jungletv.Notification} returns this
 */
proto.jungletv.Notification.prototype.clearNavigationDestinationHighlighted = function() {
  return this.setNavigationDestinationHighlighted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jungletv.Notification.prototype.hasNavigationDestinationHighlighted = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional ToastNotification toast = 9;
 * @return {?proto.jungletv.ToastNotification}
 */
proto.jungletv.Notification.prototype.getToast = function() {
  return /** @type{?proto.jungletv.ToastNotification} */ (
    jspb.Message.getWrapperField(this, proto.jungletv.ToastNotification, 9));
};


/**
 * @param {?proto.jungletv.ToastNotification|undefined} value
 * @return {!proto.jungletv.Notification} returns this
*/
proto.jungletv.Notification.prototype.setToast = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.jungletv.Notification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jungletv.Notification} returns this
 */
proto.jungletv.Notification.prototype.clearToast = function() {
  return this.setToast(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jungletv.Notification.prototype.hasToast = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jungletv.ChatMentionNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.jungletv.ChatMentionNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jungletv.ChatMentionNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jungletv.ChatMentionNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    messageId: jspb.Message.getFieldWithDefault(msg, 1, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jungletv.ChatMentionNotification}
 */
proto.jungletv.ChatMentionNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jungletv.ChatMentionNotification;
  return proto.jungletv.ChatMentionNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jungletv.ChatMentionNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jungletv.ChatMentionNotification}
 */
proto.jungletv.ChatMentionNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setMessageId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jungletv.ChatMentionNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jungletv.ChatMentionNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jungletv.ChatMentionNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jungletv.ChatMentionNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessageId();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
};


/**
 * optional int64 message_id = 1;
 * @return {string}
 */
proto.jungletv.ChatMentionNotification.prototype.getMessageId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.ChatMentionNotification} returns this
 */
proto.jungletv.ChatMentionNotification.prototype.setMessageId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jungletv.AnnouncementsUpdatedNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.jungletv.AnnouncementsUpdatedNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jungletv.AnnouncementsUpdatedNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jungletv.AnnouncementsUpdatedNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    notificationCounter: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jungletv.AnnouncementsUpdatedNotification}
 */
proto.jungletv.AnnouncementsUpdatedNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jungletv.AnnouncementsUpdatedNotification;
  return proto.jungletv.AnnouncementsUpdatedNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jungletv.AnnouncementsUpdatedNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jungletv.AnnouncementsUpdatedNotification}
 */
proto.jungletv.AnnouncementsUpdatedNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNotificationCounter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jungletv.AnnouncementsUpdatedNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jungletv.AnnouncementsUpdatedNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jungletv.AnnouncementsUpdatedNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jungletv.AnnouncementsUpdatedNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNotificationCounter();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 notification_counter = 1;
 * @return {number}
 */
proto.jungletv.AnnouncementsUpdatedNotification.prototype.getNotificationCounter = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.jungletv.AnnouncementsUpdatedNotification} returns this
 */
proto.jungletv.AnnouncementsUpdatedNotification.prototype.setNotificationCounter = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jungletv.RewardBalanceUpdatedNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.jungletv.RewardBalanceUpdatedNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jungletv.RewardBalanceUpdatedNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jungletv.RewardBalanceUpdatedNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    rewardBalance: jspb.Message.getFieldWithDefault(msg, 1, ""),
    difference: jspb.Message.getFieldWithDefault(msg, 2, ""),
    reason: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jungletv.RewardBalanceUpdatedNotification}
 */
proto.jungletv.RewardBalanceUpdatedNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jungletv.RewardBalanceUpdatedNotification;
  return proto.jungletv.RewardBalanceUpdatedNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jungletv.RewardBalanceUpdatedNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jungletv.RewardBalanceUpdatedNotification}
 */
proto.jungletv.RewardBalanceUpdatedNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRewardBalance(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDifference(value);
      break;
    case 3:
      var value = /** @type {!proto.jungletv.RewardBalanceUpdateReason} */ (reader.readEnum());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jungletv.RewardBalanceUpdatedNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jungletv.RewardBalanceUpdatedNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jungletv.RewardBalanceUpdatedNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jungletv.RewardBalanceUpdatedNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRewardBalance();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDifference();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getReason();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional string reward_balance = 1;
 * @return {string}
 */
proto.jungletv.RewardBalanceUpdatedNotification.prototype.getRewardBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.RewardBalanceUpdatedNotification} returns this
 */
proto.jungletv.RewardBalanceUpdatedNotification.prototype.setRewardBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string difference = 2;
 * @return {string}
 */
proto.jungletv.RewardBalanceUpdatedNotification.prototype.getDifference = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.RewardBalanceUpdatedNotification} returns this
 */
proto.jungletv.RewardBalanceUpdatedNotification.prototype.setDifference = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional RewardBalanceUpdateReason reason = 3;
 * @return {!proto.jungletv.RewardBalanceUpdateReason}
 */
proto.jungletv.RewardBalanceUpdatedNotification.prototype.getReason = function() {
  return /** @type {!proto.jungletv.RewardBalanceUpdateReason} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.jungletv.RewardBalanceUpdateReason} value
 * @return {!proto.jungletv.RewardBalanceUpdatedNotification} returns this
 */
proto.jungletv.RewardBalanceUpdatedNotification.prototype.setReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jungletv.SidebarTabHighlightedNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.jungletv.SidebarTabHighlightedNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jungletv.SidebarTabHighlightedNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jungletv.SidebarTabHighlightedNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    tabId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jungletv.SidebarTabHighlightedNotification}
 */
proto.jungletv.SidebarTabHighlightedNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jungletv.SidebarTabHighlightedNotification;
  return proto.jungletv.SidebarTabHighlightedNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jungletv.SidebarTabHighlightedNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jungletv.SidebarTabHighlightedNotification}
 */
proto.jungletv.SidebarTabHighlightedNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTabId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jungletv.SidebarTabHighlightedNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jungletv.SidebarTabHighlightedNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jungletv.SidebarTabHighlightedNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jungletv.SidebarTabHighlightedNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTabId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string tab_id = 1;
 * @return {string}
 */
proto.jungletv.SidebarTabHighlightedNotification.prototype.getTabId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.SidebarTabHighlightedNotification} returns this
 */
proto.jungletv.SidebarTabHighlightedNotification.prototype.setTabId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jungletv.NavigationDestinationHighlightedNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.jungletv.NavigationDestinationHighlightedNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jungletv.NavigationDestinationHighlightedNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jungletv.NavigationDestinationHighlightedNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    destinationId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jungletv.NavigationDestinationHighlightedNotification}
 */
proto.jungletv.NavigationDestinationHighlightedNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jungletv.NavigationDestinationHighlightedNotification;
  return proto.jungletv.NavigationDestinationHighlightedNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jungletv.NavigationDestinationHighlightedNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jungletv.NavigationDestinationHighlightedNotification}
 */
proto.jungletv.NavigationDestinationHighlightedNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDestinationId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jungletv.NavigationDestinationHighlightedNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jungletv.NavigationDestinationHighlightedNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jungletv.NavigationDestinationHighlightedNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jungletv.NavigationDestinationHighlightedNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDestinationId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string destination_id = 1;
 * @return {string}
 */
proto.jungletv.NavigationDestinationHighlightedNotification.prototype.getDestinationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.NavigationDestinationHighlightedNotification} returns this
 */
proto.jungletv.NavigationDestinationHighlightedNotification.prototype.setDestinationId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jungletv.ToastNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.jungletv.ToastNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jungletv.ToastNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jungletv.ToastNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    message: jspb.Message.getFieldWithDefault(msg, 1, ""),
    href: jspb.Message.getFieldWithDefault(msg, 2, ""),
    duration: (f = msg.getDuration()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jungletv.ToastNotification}
 */
proto.jungletv.ToastNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jungletv.ToastNotification;
  return proto.jungletv.ToastNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jungletv.ToastNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jungletv.ToastNotification}
 */
proto.jungletv.ToastNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHref(value);
      break;
    case 3:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setDuration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jungletv.ToastNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jungletv.ToastNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jungletv.ToastNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jungletv.ToastNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHref();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDuration();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.jungletv.ToastNotification.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.ToastNotification} returns this
 */
proto.jungletv.ToastNotification.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string href = 2;
 * @return {string}
 */
proto.jungletv.ToastNotification.prototype.getHref = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.ToastNotification} returns this
 */
proto.jungletv.ToastNotification.prototype.setHref = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Duration duration = 3;
 * @return {?proto.google.protobuf.Duration}
 */
proto.jungletv.ToastNotification.prototype.getDuration = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 3));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.jungletv.ToastNotification} returns this
*/
proto.jungletv.ToastNotification.prototype.setDuration = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jungletv.ToastNotification} returns this
 */
proto.jungletv.ToastNotification.prototype.clearDuration = function() {
  return this.setDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jungletv.ToastNotification.prototype.hasDuration = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.jungletv.ConfigurationChange.oneofGroups_ = [[1,2,3,4,5,6,7]];

/**
 * @enum {number}
 */
proto.jungletv.ConfigurationChange.ConfigurationChangeCase = {
  CONFIGURATION_CHANGE_NOT_SET: 0,
  APPLICATION_NAME: 1,
  LOGO_URL: 2,
  FAVICON_URL: 3,
  OPEN_SIDEBAR_TAB: 4,
  CLOSE_SIDEBAR_TAB: 5,
  ADD_NAVIGATION_DESTINATION: 6,
  REMOVE_NAVIGATION_DESTINATION: 7
};

/**
 * @return {proto.jungletv.ConfigurationChange.ConfigurationChangeCase}
 */
proto.jungletv.ConfigurationChange.prototype.getConfigurationChangeCase = function() {
  return /** @type {proto.jungletv.ConfigurationChange.ConfigurationChangeCase} */(jspb.Message.computeOneofCase(this, proto.jungletv.ConfigurationChange.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jungletv.ConfigurationChange.prototype.toObject = function(opt_includeInstance) {
  return proto.jungletv.ConfigurationChange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jungletv.ConfigurationChange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jungletv.ConfigurationChange.toObject = function(includeInstance, msg) {
  var f, obj = {
    applicationName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    logoUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
    faviconUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
    openSidebarTab: (f = msg.getOpenSidebarTab()) && proto.jungletv.ConfigurationChangeSidebarTabOpen.toObject(includeInstance, f),
    closeSidebarTab: jspb.Message.getFieldWithDefault(msg, 5, ""),
    addNavigationDestination: (f = msg.getAddNavigationDestination()) && proto.jungletv.ConfigurationChangeAddNavigationDestination.toObject(includeInstance, f),
    removeNavigationDestination: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jungletv.ConfigurationChange}
 */
proto.jungletv.ConfigurationChange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jungletv.ConfigurationChange;
  return proto.jungletv.ConfigurationChange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jungletv.ConfigurationChange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jungletv.ConfigurationChange}
 */
proto.jungletv.ConfigurationChange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplicationName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogoUrl(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFaviconUrl(value);
      break;
    case 4:
      var value = new proto.jungletv.ConfigurationChangeSidebarTabOpen;
      reader.readMessage(value,proto.jungletv.ConfigurationChangeSidebarTabOpen.deserializeBinaryFromReader);
      msg.setOpenSidebarTab(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCloseSidebarTab(value);
      break;
    case 6:
      var value = new proto.jungletv.ConfigurationChangeAddNavigationDestination;
      reader.readMessage(value,proto.jungletv.ConfigurationChangeAddNavigationDestination.deserializeBinaryFromReader);
      msg.setAddNavigationDestination(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRemoveNavigationDestination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jungletv.ConfigurationChange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jungletv.ConfigurationChange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jungletv.ConfigurationChange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jungletv.ConfigurationChange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOpenSidebarTab();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.jungletv.ConfigurationChangeSidebarTabOpen.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAddNavigationDestination();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.jungletv.ConfigurationChangeAddNavigationDestination.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string application_name = 1;
 * @return {string}
 */
proto.jungletv.ConfigurationChange.prototype.getApplicationName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.ConfigurationChange} returns this
 */
proto.jungletv.ConfigurationChange.prototype.setApplicationName = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.jungletv.ConfigurationChange.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.jungletv.ConfigurationChange} returns this
 */
proto.jungletv.ConfigurationChange.prototype.clearApplicationName = function() {
  return jspb.Message.setOneofField(this, 1, proto.jungletv.ConfigurationChange.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jungletv.ConfigurationChange.prototype.hasApplicationName = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string logo_url = 2;
 * @return {string}
 */
proto.jungletv.ConfigurationChange.prototype.getLogoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.ConfigurationChange} returns this
 */
proto.jungletv.ConfigurationChange.prototype.setLogoUrl = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.jungletv.ConfigurationChange.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.jungletv.ConfigurationChange} returns this
 */
proto.jungletv.ConfigurationChange.prototype.clearLogoUrl = function() {
  return jspb.Message.setOneofField(this, 2, proto.jungletv.ConfigurationChange.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jungletv.ConfigurationChange.prototype.hasLogoUrl = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string favicon_url = 3;
 * @return {string}
 */
proto.jungletv.ConfigurationChange.prototype.getFaviconUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.ConfigurationChange} returns this
 */
proto.jungletv.ConfigurationChange.prototype.setFaviconUrl = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.jungletv.ConfigurationChange.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.jungletv.ConfigurationChange} returns this
 */
proto.jungletv.ConfigurationChange.prototype.clearFaviconUrl = function() {
  return jspb.Message.setOneofField(this, 3, proto.jungletv.ConfigurationChange.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jungletv.ConfigurationChange.prototype.hasFaviconUrl = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ConfigurationChangeSidebarTabOpen open_sidebar_tab = 4;
 * @return {?proto.jungletv.ConfigurationChangeSidebarTabOpen}
 */
proto.jungletv.ConfigurationChange.prototype.getOpenSidebarTab = function() {
  return /** @type{?proto.jungletv.ConfigurationChangeSidebarTabOpen} */ (
    jspb.Message.getWrapperField(this, proto.jungletv.ConfigurationChangeSidebarTabOpen, 4));
};


/**
 * @param {?proto.jungletv.ConfigurationChangeSidebarTabOpen|undefined} value
 * @return {!proto.jungletv.ConfigurationChange} returns this
*/
proto.jungletv.ConfigurationChange.prototype.setOpenSidebarTab = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.jungletv.ConfigurationChange.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jungletv.ConfigurationChange} returns this
 */
proto.jungletv.ConfigurationChange.prototype.clearOpenSidebarTab = function() {
  return this.setOpenSidebarTab(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jungletv.ConfigurationChange.prototype.hasOpenSidebarTab = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string close_sidebar_tab = 5;
 * @return {string}
 */
proto.jungletv.ConfigurationChange.prototype.getCloseSidebarTab = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.ConfigurationChange} returns this
 */
proto.jungletv.ConfigurationChange.prototype.setCloseSidebarTab = function(value) {
  return jspb.Message.setOneofField(this, 5, proto.jungletv.ConfigurationChange.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.jungletv.ConfigurationChange} returns this
 */
proto.jungletv.ConfigurationChange.prototype.clearCloseSidebarTab = function() {
  return jspb.Message.setOneofField(this, 5, proto.jungletv.ConfigurationChange.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jungletv.ConfigurationChange.prototype.hasCloseSidebarTab = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional ConfigurationChangeAddNavigationDestination add_navigation_destination = 6;
 * @return {?proto.jungletv.ConfigurationChangeAddNavigationDestination}
 */
proto.jungletv.ConfigurationChange.prototype.getAddNavigationDestination = function() {
  return /** @type{?proto.jungletv.ConfigurationChangeAddNavigationDestination} */ (
    jspb.Message.getWrapperField(this, proto.jungletv.ConfigurationChangeAddNavigationDestination, 6));
};


/**
 * @param {?proto.jungletv.ConfigurationChangeAddNavigationDestination|undefined} value
 * @return {!proto.jungletv.ConfigurationChange} returns this
*/
proto.jungletv.ConfigurationChange.prototype.setAddNavigationDestination = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.jungletv.ConfigurationChange.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jungletv.ConfigurationChange} returns this
 */
proto.jungletv.ConfigurationChange.prototype.clearAddNavigationDestination = function() {
  return this.setAddNavigationDestination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jungletv.ConfigurationChange.prototype.hasAddNavigationDestination = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string remove_navigation_destination = 7;
 * @return {string}
 */
proto.jungletv.ConfigurationChange.prototype.getRemoveNavigationDestination = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.ConfigurationChange} returns this
 */
proto.jungletv.ConfigurationChange.prototype.setRemoveNavigationDestination = function(value) {
  return jspb.Message.setOneofField(this, 7, proto.jungletv.ConfigurationChange.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.jungletv.ConfigurationChange} returns this
 */
proto.jungletv.ConfigurationChange.prototype.clearRemoveNavigationDestination = function() {
  return jspb.Message.setOneofField(this, 7, proto.jungletv.ConfigurationChange.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jungletv.ConfigurationChange.prototype.hasRemoveNavigationDestination = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jungletv.ConfigurationChangeSidebarTabOpen.prototype.toObject = function(opt_includeInstance) {
  return proto.jungletv.ConfigurationChangeSidebarTabOpen.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jungletv.ConfigurationChangeSidebarTabOpen} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jungletv.ConfigurationChangeSidebarTabOpen.toObject = function(includeInstance, msg) {
  var f, obj = {
    tabId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    applicationId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    pageId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    tabTitle: jspb.Message.getFieldWithDefault(msg, 4, ""),
    beforeTabId: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jungletv.ConfigurationChangeSidebarTabOpen}
 */
proto.jungletv.ConfigurationChangeSidebarTabOpen.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jungletv.ConfigurationChangeSidebarTabOpen;
  return proto.jungletv.ConfigurationChangeSidebarTabOpen.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jungletv.ConfigurationChangeSidebarTabOpen} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jungletv.ConfigurationChangeSidebarTabOpen}
 */
proto.jungletv.ConfigurationChangeSidebarTabOpen.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTabId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplicationId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTabTitle(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBeforeTabId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jungletv.ConfigurationChangeSidebarTabOpen.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jungletv.ConfigurationChangeSidebarTabOpen.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jungletv.ConfigurationChangeSidebarTabOpen} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jungletv.ConfigurationChangeSidebarTabOpen.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTabId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getApplicationId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTabTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBeforeTabId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string tab_id = 1;
 * @return {string}
 */
proto.jungletv.ConfigurationChangeSidebarTabOpen.prototype.getTabId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.ConfigurationChangeSidebarTabOpen} returns this
 */
proto.jungletv.ConfigurationChangeSidebarTabOpen.prototype.setTabId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string application_id = 2;
 * @return {string}
 */
proto.jungletv.ConfigurationChangeSidebarTabOpen.prototype.getApplicationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.ConfigurationChangeSidebarTabOpen} returns this
 */
proto.jungletv.ConfigurationChangeSidebarTabOpen.prototype.setApplicationId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string page_id = 3;
 * @return {string}
 */
proto.jungletv.ConfigurationChangeSidebarTabOpen.prototype.getPageId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.ConfigurationChangeSidebarTabOpen} returns this
 */
proto.jungletv.ConfigurationChangeSidebarTabOpen.prototype.setPageId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string tab_title = 4;
 * @return {string}
 */
proto.jungletv.ConfigurationChangeSidebarTabOpen.prototype.getTabTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.ConfigurationChangeSidebarTabOpen} returns this
 */
proto.jungletv.ConfigurationChangeSidebarTabOpen.prototype.setTabTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string before_tab_id = 5;
 * @return {string}
 */
proto.jungletv.ConfigurationChangeSidebarTabOpen.prototype.getBeforeTabId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.ConfigurationChangeSidebarTabOpen} returns this
 */
proto.jungletv.ConfigurationChangeSidebarTabOpen.prototype.setBeforeTabId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jungletv.ConfigurationChangeAddNavigationDestination.prototype.toObject = function(opt_includeInstance) {
  return proto.jungletv.ConfigurationChangeAddNavigationDestination.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jungletv.ConfigurationChangeAddNavigationDestination} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jungletv.ConfigurationChangeAddNavigationDestination.toObject = function(includeInstance, msg) {
  var f, obj = {
    destinationId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    label: jspb.Message.getFieldWithDefault(msg, 2, ""),
    icon: jspb.Message.getFieldWithDefault(msg, 3, ""),
    href: jspb.Message.getFieldWithDefault(msg, 4, ""),
    color: jspb.Message.getFieldWithDefault(msg, 5, ""),
    beforeDestinationId: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jungletv.ConfigurationChangeAddNavigationDestination}
 */
proto.jungletv.ConfigurationChangeAddNavigationDestination.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jungletv.ConfigurationChangeAddNavigationDestination;
  return proto.jungletv.ConfigurationChangeAddNavigationDestination.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jungletv.ConfigurationChangeAddNavigationDestination} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jungletv.ConfigurationChangeAddNavigationDestination}
 */
proto.jungletv.ConfigurationChangeAddNavigationDestination.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDestinationId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIcon(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setHref(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setColor(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBeforeDestinationId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jungletv.ConfigurationChangeAddNavigationDestination.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jungletv.ConfigurationChangeAddNavigationDestination.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jungletv.ConfigurationChangeAddNavigationDestination} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jungletv.ConfigurationChangeAddNavigationDestination.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDestinationId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIcon();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHref();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBeforeDestinationId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string destination_id = 1;
 * @return {string}
 */
proto.jungletv.ConfigurationChangeAddNavigationDestination.prototype.getDestinationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.ConfigurationChangeAddNavigationDestination} returns this
 */
proto.jungletv.ConfigurationChangeAddNavigationDestination.prototype.setDestinationId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.jungletv.ConfigurationChangeAddNavigationDestination.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.ConfigurationChangeAddNavigationDestination} returns this
 */
proto.jungletv.ConfigurationChangeAddNavigationDestination.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string icon = 3;
 * @return {string}
 */
proto.jungletv.ConfigurationChangeAddNavigationDestination.prototype.getIcon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.ConfigurationChangeAddNavigationDestination} returns this
 */
proto.jungletv.ConfigurationChangeAddNavigationDestination.prototype.setIcon = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string href = 4;
 * @return {string}
 */
proto.jungletv.ConfigurationChangeAddNavigationDestination.prototype.getHref = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.ConfigurationChangeAddNavigationDestination} returns this
 */
proto.jungletv.ConfigurationChangeAddNavigationDestination.prototype.setHref = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string color = 5;
 * @return {string}
 */
proto.jungletv.ConfigurationChangeAddNavigationDestination.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.ConfigurationChangeAddNavigationDestination} returns this
 */
proto.jungletv.ConfigurationChangeAddNavigationDestination.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string before_destination_id = 6;
 * @return {string}
 */
proto.jungletv.ConfigurationChangeAddNavigationDestination.prototype.getBeforeDestinationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.jungletv.ConfigurationChangeAddNavigationDestination} returns this
 */
proto.jungletv.ConfigurationChangeAddNavigationDestination.prototype.setBeforeDestinationId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * @enum {number}
 */
proto.jungletv.UserRole = {
  MODERATOR: 0,
  TIER_1_REQUESTER: 1,
  TIER_2_REQUESTER: 2,
  TIER_3_REQUESTER: 3,
  CURRENT_ENTRY_REQUESTER: 4,
  VIP: 5,
  APPLICATION: 6
};

/**
 * @enum {number}
 */
proto.jungletv.UserStatus = {
  USER_STATUS_OFFLINE: 0,
  USER_STATUS_WATCHING: 1,
  USER_STATUS_AWAY: 2
};

/**
 * @enum {number}
 */
proto.jungletv.RewardBalanceUpdateReason = {
  REWARD_BALANCE_UPDATE_REASON_UNKNOWN: 0,
  REWARD_BALANCE_UPDATE_REASON_REWARD_RECEIVED: 1,
  REWARD_BALANCE_UPDATE_REASON_WITHDRAW: 2
};

goog.object.extend(exports, proto.jungletv);
